import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FormSubmissionService {
  private apiBaseUrl = `${environment.apiDomain}/auto-insurance`;
  constructor(private http: HttpClient) { }

  submitForm(data: any, stepName: string, sessionId: string): Observable<any> {
    return this.http.post(`${this.apiBaseUrl}/update-details`, data, {
      headers: { 'Content-Type': 'application/json' },
      params: { uuid: sessionId, stepName }
    });
  }

  getUserOffers(sessionId: string): Observable<any> {
     return this.http.post(`${this.apiBaseUrl}/user-offers`, {}, {
      headers: { 'Content-Type': 'application/json' },
      params: { uuid: sessionId }
    });

    /*return this.http.get("assets/test-data.json",  {
      headers: { 'Content-Type': 'application/json' },
    });*/
  }

  getRedirectLink(sessionId: string): Observable<any> {
    return this.http.get(`${this.apiBaseUrl}/generate-redirect-link`, {
     headers: { 'Content-Type': 'application/json' },
     params: { uuid: sessionId }
   });  
 }
}
